<template>
  <div role="region">
    <div v-if="updateAddress || !showOfferCards || modalLayout"
         class=""
         :class="classes">
      <div :class="[modalLayout ? '' : 'pb-4', form.type === 'full'? 'max-w-5xl': 'max-w-3xl']"
           class="container mx-auto px-4">
        <div class="flex" :class="modalLayout ? '' : 'justify-center'">
          <h2 v-if="heading"
              class="text-xl my-4 smMobile:text-xl mdMobile:text-4lg tablet:text-2xl desktop:text-3xl text-navy-dark">
            {{ heading }}</h2>
          <p v-if="subheading" class="text-base tablet:text-lg text-navy-dark">{{ subheading }}</p>
        </div>
        <div v-if="highlight.message"
             class="mb-4 flex items-start"
             :class="modalLayout ? '' : 'mb-4 mdMobile:mx-4 justify-center flex items-start'">
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="25" viewBox="0 0 24 25" fill="none">
            <g clip-path="url(#clip0_4714_4430)">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M23.3491 10.4484L13.5703 0.675579C13.1532 0.260323 12.5886 0.0271912 12 0.0271912C11.4114 0.0271912 10.8468 0.260323 10.4297 0.675579L0.650921 10.4484C0.234016 10.8676 0 11.4349 0 12.0262C0 12.6174 0.234016 13.1847 0.650921 13.604L10.4297 23.3737C10.8468 23.789 11.4114 24.0221 12 24.0221C12.5886 24.0221 13.1532 23.789 13.5703 23.3737L23.3491 13.604C23.766 13.1847 24 12.6174 24 12.0262C24 11.4349 23.766 10.8676 23.3491 10.4484ZM13.2435 4.83906L12.8925 13.9099H11.0688L10.7178 4.83906H13.2435ZM11.4104 19.1023C11.5946 19.1792 11.7928 19.217 11.9924 19.2133C12.1978 19.2178 12.402 19.18 12.5923 19.1023C12.7732 19.0275 12.9374 18.9173 13.0752 18.7783C13.2092 18.6342 13.3113 18.4635 13.3752 18.2774C13.5008 17.903 13.4912 17.4965 13.3482 17.1285C13.2759 16.9486 13.1677 16.7853 13.0302 16.6486C12.8936 16.5124 12.7315 16.4044 12.5533 16.3306C12.3756 16.2565 12.1849 16.2188 11.9924 16.2196C11.8073 16.2148 11.623 16.2454 11.4494 16.3096C11.272 16.3849 11.1103 16.4928 10.9725 16.6276C10.837 16.7659 10.7291 16.9288 10.6545 17.1075C10.5801 17.2862 10.5424 17.4779 10.5436 17.6715C10.5262 17.875 10.5539 18.0798 10.6245 18.2714C10.6885 18.4575 10.7907 18.6281 10.9245 18.7723C11.061 18.9158 11.2267 19.0284 11.4104 19.1023Z"
                    fill="#C70032"/>
            </g>
            <defs>
              <clipPath id="clip0_4714_4430">
                <rect width="24" height="23.997" fill="white" transform="translate(0 0.0276794)"/>
              </clipPath>
            </defs>
          </svg>
          <div
              class="inline smMobile:ml-2 tablet:ml-2 items-center"
              :class="modalLayout ? 'smMobile:inline' : ''">
            <span class="text-base font-semibold tablet:text-lg desktop:text-lg text-navy-dark"
                  v-html="highlight.message"> </span>
            <span
                class=""
                :class="[
                                    highlight.csgSuggestions ? 'highlight.message5Class' : 'tablet:ml-1 highlight.message4Class',
                                    modalLayout ? 'items-center smMobile:inline desktop:text-lg' : '']"
            > {{ highlight.csgSuggestions ? highlight.message5 : highlight.message4 }}</span>
            <span v-if="highlight.inputChanged" v-html="highlight.message6"></span>
          </div>
        </div>
        <form class="gap-1.5 grid grid-cols-6"
              :class="modalLayout ? 'desktop:grid-cols-10 tablet:grid-cols-10' : 'mt-0 tablet:w-full tablet:justify-center'">
          <!-- The classes laid out below are applied dynamically based on the different states for CheckServiceAvailability -->
          <!-- The three states are: Main Address in field, modalLayout: CheckServiceAvailabilityModal, baseForm: return this.form.type === 'full' && this.form.completeType !== 'csg'  -->
          <div @focusout="hideSuggestions('showSuggestions')"
               :class="{
                            'tablet:col-span-full' : !baseForm && modalLayout,
                            'tablet:col-span-10' : modalLayout,
                            'tablet:ml-8' : !modalLayout && baseForm,
                            'tablet:col-span-4' : baseForm,
                            'tablet:col-span-full desktop:col-start-2 desktop:col-span-4' : !baseForm && !modalLayout
                            }"
               class="col-span-full relative">
            <p class="text-navy-dark text-left font-bold"> Street address </p>
            <input
                v-model="typeAhead.street"
                class="h-30 block w-full ca-street-address rounded-lg focus:border-blue-light"
                :class="highlight.line1? 'border-red-500' : 'border-gray-300'"
                type="text"
                maxlength="75"
                placeholder="1234 Your Street"
                data-qa="addressInput"
                @input="onInput"
                @focusin="onFocus(); typeAhead.showSuggestions = true; typeAhead.showAptSuggestions = false; highlight.line1 = false"
            />
            <div v-show="typeAhead.showSuggestions && typeAhead.street.length > 0 && typeAhead.suggestions.length > 0"
                 class="w-full absolute bg-gray-50 border-2 border-gray-300 rounded-lg overflow-hidden shadow-md z-20">
              <p v-for="(suggestion, index) in typeAhead.suggestions"
                 :key="index"
                 :class="{'pt-4': index === 0,'pb-4': typeAhead.suggestions.length - 1 === index}"
                 class="w-full px-4 py-2.5 cursor-pointer text-gray-500 xsMobile:text-sm smMobile:text-md hover:bg-gray-100 hover:text-navy flex items-center truncate"
                 @click="selectSuggestion(suggestion)"
              >
                <IconPin classes="pr-1.5 flex-shrink-0"></IconPin>
                <span v-html="suggestion.formatted"/>
              </p>
              <a v-if="form.type === 'quick'" @click="reset(); updateAddress = true; changeForm('full', true, 'google')"
                 class="text-sm pl-8 pr-4 py-3.5 cursor-pointer text-white bg-navy hover:bg-navy-dark flex items-center gap-2">
                Try a new address
              </a>
              <a v-else-if="form.completeType === 'csg'" @click="reset(); updateAddress = true"
                 class="text-sm pl-8 pr-4 py-3.5 cursor-pointer text-white bg-navy hover:bg-navy-dark flex items-center gap-2">
                Try a new address
              </a>
            </div>
            <div v-if="highlight.message" class="flex items-center">
              <p class="text-red-600 my-2 text-base smMobile:text-sm tablet:text-sm" v-html="highlight.message2"></p>
            </div>
          </div>
          <div v-if="baseForm" class=""
               :class="modalLayout ? 'smMobile:col-span-3 tablet:col-span-5 desktop:col-start-1' : 'col-span-3 tablet:col-span-2 desktop:col-span-2 tablet:col-start-5'">
            <p class="text-left text-navy-dark font-bold desktop:text-base"> Apt/Unit # </p>
            <input
                v-model="formFields.line2"
                class="h-30 block w-full rounded-lg focus:border-blue-light"
                :class="highlight.line2? 'border-red-500': 'border-gray-300'"
                type="text"
                data-qa="apartmentInput"
                maxlength="30"
                placeholder="Apt 123"
                @input="aptChanged"
                @focusin="typeAhead.showAptSuggestions = true; typeAhead.showSuggestions = false; highlight.line2 = false"
            />
          </div>
          <div v-if="baseForm" class=""
               :class="modalLayout ? 'smMobile:col-span-3 smMobile:col-start-4 tablet:col-span-5 tablet:col-start-6' : 'col-span-3 tablet:col-span-2 tablet:col-start-7 desktop:col-start-7'">
            <p class="text-left text-navy-dark font-bold"> ZIP Code </p>
            <input
                v-model="formFields.postalCode"
                class="h-30 block w-full rounded-lg focus:border-blue-light"
                :class="highlight.postalCode? 'border-red-500': 'border-gray-300'"
                data-qa="zipcodeInput"
                type="text"
                maxlength="5"
                minlength="5"
                placeholder="5-digits"
                @focusin="highlight.postalCode = false"
            />
            <div v-if="highlight.message" class="flex items-center">
              <p class="text-red-600 my-2 text-base smMobile:text-sm tablet:text-sm" v-html="highlight.message3"></p>
            </div>
          </div>
          <div v-if="form.completeType !== 'csg'"
               class="col-span-full smMobile:flex smMobile:w-full tablet:grid tablet:mt-0 flex  mx-auto min-w-30 mt-1 tablet:mx-0 tablet:mt-0"
               :class="[
                            modalLayout ? 'w-full flex-col tablet:col-span-10 mb-1 desktop:col-start-1' : 'desktop:col-start-9 tablet:col-span-2 justify-center tablet:col-start-9 tablet:justify-start',
                            modalLayoutClass ? modalLayoutClass : '',
                            initialLayout ? initialLayout : ''
                        ]">
            <div v-if="modalLayout" class="flex my-2">
              <p class="text-navy-dark text-2xs smMobile:text-md tablet:text-base desktop:text-sm">
                This site is protected by reCAPTCHA and the
                Google
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://policies.google.com/privacy"
                >Privacy Policy</a
                >
                and
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://policies.google.com/terms"
                >Terms of Service</a
                >&nbsp;apply.
              </p>
            </div>
            <div
                class=""
                :class="modalLayout ? 'tablet:grid tablet:grid-cols-9 smMobile:w-full smMobile:flex smMobile:flex-col-reverse' : 'smMobile:w-full smMobile:mt-2.5 smMobile:gap-2.5 tablet:mt-0 tablet:flex-row'">
              <button
                  v-if="modalLayout"
                  @click.prevent="cancelModal()"
                  class="mx-auto rounded-3xl text-md p-2 bg-white border-2 border-blue rounded-3xl items-center justify-center smMobile:w-full desktop:min-h-12 tablet:min-h-13 text-md font-bold text-blue border-blue focus:outline-none focus:border-blue"
                  :class="modalLayout ? 'smMobile:w-full smMobile:mb-4 tablet:mt-4 tablet:col-start-4 tablet:col-span-2 tablet:-ml-4 deskto:-ml-2 desktop:col-start-4 desktop:col-span-2 mx-auto' : 'smMobile:mr-0 mr-2 tablet:-mt-4'"
              >
                Cancel
              </button>
              <button
                  @click.prevent="onSubmit()"
                  type="submit"
                  class="h-30 smMobile:w-full smMobile:mr-0 desktop:min-h-12 tablet:min-h-13 font-bold text-white focus:outline-none focus:border-blue"
                  :class="[
                                    modalLayout && !this.highlight.message ? 'mx-auto py-2.5 text-md text-white bg-blue smMobile:items-center smMobile:my-4 smMobile:flex smMobile:flex-col-reverse tablet:grid tablet:col-start-6 tablet:col-span-4 desktop:col-start-6 desktop:col-span-4' : 'flex',
                                    modalLayout && this.highlight.message ? 'mx-auto py-2.5 rounded-3xl text-md text-white bg-blue justify-center smMobile:items-center smMobile:my-4 smMobile:flex smMobile:flex-col-reverse tablet:grid tablet:col-start-6 tablet:col-span-4 desktop:col-start-6 desktop:col-span-4' : 'flex',
                                    !modalLayout || !this.highlight.message ? 'mx-auto rounded-3xl text-md p-4.5 bg-white border-2 border-blue rounded-3xl items-center justify-center' : '',
                                    !modalLayout && !this.highlight.message && 'text-white' ? 'text-blue' : '',
                                    !modalLayout || this.highlight.message ? '-mt-3.5 mx-auto py-2.5 p-4.5 mx-auto rounded-3xl text-md bg-white border-2 border-blue rounded-3xl items-center justify-center' : '',
                                    !modalLayout && this.highlight.message && 'text-white' ? 'text-blue' : '',
                                ]"
              >
                Check Availability
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-else>
      <div class="bg-navy-dark text-white text-center">
        <div class="container py-4 flex flex-col tablet:flex-row items-center justify-center gap-1 tablet:gap-2">
          <div class="flex gap-2">
            <IconPinMap classes="flex-shrink-0 h-5 w-5"></IconPinMap>
            <span class="font-bold">Your Location:</span>
          </div>
          {{ addressString }}
          <button
              id="change-zip"
              class="underline"
              data-cy="check-address"
              data-category="Verify Address not into buyflow"
              @click.prevent="updateLocation">
            {{ addressString ? "Edit" : "Check Availability?" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {Loader} from "@googlemaps/js-api-loader";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";

import IconPin from "@/atoms/icons/IconPin";
import IconPinMap from "@/atoms/icons/IconPinMap";
import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation";
import {mapGetters, mapState, mapActions} from "vuex";
// Google Recaptcha V3 for Vue v2.x - https://github.com/AurityLab/vue-recaptcha-v3/tree/vue-v2.x //
import {VueReCaptcha} from "vue-recaptcha-v3";
import {DateTime as dt} from "luxon";
import {captureMessage} from "@sentry/browser";
import rightOfEntry from '../../../utils/rightOfEntry'


const dataFactory = () => {
  return {
    typeAhead: {
      street: '',
      long: '',
      short: '',
      inputChanged: false,
      selectedOption: false,
      showSuggestions: false,
      showAptSuggestions: false,
      csgSuggestions: null,
      aptSuggestions: [],
      suggestions: [],
    },
    google: {
      debounceTimer: null,
      placeDetails: null,
    },
    form: {
      type: 'full', // quick or full
      autocomplete: true, // true or false
      completeType: 'google', // google or csg
    },
    formFields: {
      line1: '',
      line2: '',
      city: 'Not Provided',
      stateOrProvince: 'NP',
      postalCode: '',
      recaptchaToken: '',
    },
    attempts: 0,
    updateAddress: false,
    requestStartTime: null
  }
}


export default {
  name: 'CheckServiceAvailability',
  components: {
    IconPin,
    IconCircleExclamation,
    IconPinMap,
  },
  props: {
    modalLayout: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      required: false,
      default: 'Find the best offers in your area',
    },
    subheading: {
      type: String,
      required: false,
      default: '',
    },
    classes: {
      type: String,
      required: false,
      default: 'bg-white border-t-2',
    },
    currentSiteSection: {
      type: String,
      required: false,
      default: 'residential',
    },
  },
  data() {
    const data = dataFactory();
    return {
      ...data,
      highlightMessage: false // Initialize highlightMessage as a reactive property
    };
  },
  validations: {
    formFields: {
      line1: {
        required,
      },
      line2: {},
      postalCode: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5),
        numeric,
      },
    },
  },
  mounted() {
    if(this.isRightOfEntry) {
      rightOfEntry(this.meta, this.$store);
    }
    if (!this.showOfferCards) {
      Vue.use(VueReCaptcha, {siteKey: this.$store.state.env.googleRecaptchaV3SiteKey});
    }
      this.autoAddressIn()
    },
    watch: {
		'form.type'(val) {
			this.updateStreet(val)
        },
        'typeAhead.street'(val) {
			if (!this.form.autocomplete || this.form.completeType === 'csg') {
				this.formFields.line1 = val
            }
        },
        'typeAhead.inputChanged'(val) {
            if (val && this.typeAhead.selectedOption) {
				this.changeForm('full', this.form.autocomplete, this.form.completeType)
			}
		},
	  },
    computed: {
    ...mapState({
        residentialOffers: state => state.residentialOffers
    }),
    ...mapGetters([
      'showOfferCards',
      'getCurrentAddressAsString',
    ]),
    ...mapState([
      'checkAvailabilityModal',
      'meta',
      'googleAPI'
    ]),
    isRightOfEntry() {
      return this.meta.isRightOfEntry
    },
    highlight: {
      get() {
          return this.$store.state.highlights.highlight;
      },
      set(value) {
          this.$store.commit('highlights/SET_HIGHLIGHT', value);
      }
    },
   
    linkTo() {
      return window?.checkAddressLinkTo ?? ''
    },
    addressString() {
      return this.getCurrentAddressAsString(this)
    },
    baseForm() {
      // Returns true if the form is in its default state and is not suggesting adresses from CSG
      return this.form.type === 'full' && this.form.completeType !== 'csg'
    },
    hasError() {
      return this.errorMessage !== '';
    },
    initialLayout() {
      if (this.highlight.message) {
        return 'items-center';
      } else {
        return 'items-end';
      }
    },
    modalLayoutClass() {
      if (this.modalLayout) {
        return 'items-end'; // Set the desired class for modalLayout true state
      }
    }
  },
  methods: {
    ...mapActions('highlights', [
      'resetHighlights'
    ]),
   
    autoAddressIn() {
      const urlParams = new URLSearchParams(window.location.search);
      const autoAddressKey = urlParams.get('autoAddressKey');
      if (!autoAddressKey) return;
      this.typeAhead.street = `${urlParams.get('acstreetaddress')}`;
      this.formFields.line1 = urlParams.get('acstreetaddress');
      this.formFields.line2 = urlParams.get('acunit') || '';
      this.formFields.city = urlParams.get('accity');
      this.formFields.stateOrProvince = urlParams.get('acstate');
      this.formFields.postalCode = urlParams.get('aczip');
      this.changeForm('short', false, 'autoAddress');
      this.onSubmit();
    },
    capitalize(string) {
      return string.toLowerCase()
          .split(' ')
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
    },
    reset() {
      Object.assign(this.$data, dataFactory())
    },
    updateStreet(type) {
      this.typeAhead.street = (type === 'full' ? this.typeAhead.short : this.typeAhead.long) || this.typeAhead.street;
    },
    filterSuggestions(search, list, addressPart = false) {
      if (!list) return [];

      const filtered = list.map(item => {
        if (search?.length === 0) return {...item, match: 1};
        const a = item?.address

        if (addressPart) {
          const parts = a[addressPart].toLowerCase().split('')
          const pSearch = search.replace(',', '').toLowerCase().split('')

          return {
            ...item,
            match: Math.min(Math.max((pSearch.reduce((pre, cur, ind) => parts[ind]?.includes(cur) ? 1 : 0, 0) + (a[addressPart].toLowerCase().includes(search.replace(',', '').toLowerCase()) ? 1 : 0)) / (pSearch.length + 1), 0), 1)
          }
        }
        const address = `${a.line1}${a.line2 ? ' ' + a.line2 : ''} ${a.city} ${a.stateOrProvince} ${a.postalCode}`.toLowerCase().split(' ')
        const fSearch = search.replace(',', '').toLowerCase().split(' ')

        return {
          ...item,
          match: Math.min(Math.max(fSearch.reduce((pre, cur, ind) => address[ind]?.includes(cur) ? 1 : 0, 0) / fSearch.length, 0), 1)
        }
      }).sort((a, b) => b.match - a.match).slice(0, 6)

      return filtered.length ? filtered : list.slice(0, 6)
    },
    clearFormFields() {
      this.formFields = {
        ...this.formFields,
        line1: '',
        line2: '',
        city: '',
        stateOrProvince: '',
        postalCode: '',
      };
    },
    clearTypeAheadFields() {
      this.typeAhead = {
        ...this.typeAhead,
        street: '',
        long: '',
        short: '',
      }
    },
    changeForm(type, autocomplete, completeType) {
      this.form = {
        type,
        autocomplete,
        completeType,
      }
    },
    getErrorMessage() {
      // Check for isRightOfEntry first and return early if true
      if(this.isRightOfEntry) {
        this.checkAvailabilityReporting('Right of Entry Address', {
          requestStartTime: this.requestStartTime,
          attemptNumber: this.attempts
        });
        this.resetHighlights()
        return // Exit early
      }

      this.highlight.message4 = 'Please check the following fields and try again.'
      this.highlight.message5 = `Please enter the apartment or unit number.`
      if (this.highlight.inputChanged) {
        this.highlight.message4Class = 'items-center text-base font-normal'
        this.highlight.message = `Unfortunately, Breezeline is not available at this address. `
        this.highligh.message6 = `Try again or <a href="/unserviceable-address" class="text-navy-dark underline">confirm the address you provided is correct.</a>`
      } else if (this.highlight.recaptcha) {
        this.highlight.message = `<strong>Unable to validate at this time.</strong> Please Try again later.`
      } else if (this.highlight.csgSuggestions) {
        this.highlight.message5Class = 'tablet:ml-0 items-center text-base font-normal'
        this.highlight.message = `There are multiple units at this address.`
        this.highlight.message5 = `Please enter the apartment or unit number.`
      } else if (!this.highlight.line1 && this.highlight.line2 && !this.highlight.postalCode) {
        this.highlight.message = `<strong>Apt/unit # is missing.</strong> To continue, please fill in the missing information.`
      } else if (!this.$v.formFields.postalCode.minLength || !this.$v.formFields.postalCode.maxLength) {
        this.highlight.message = 'ZIP Code must be 5 digits.'
        this.highlight.message3 = 'Enter a valid ZIP Code'
      } else if (this.highlight.line1 && this.highlight.postalCode && this.highlight.message4 === 'Please check the following fields and try again.') {
        this.highlight.message4Class = 'items-center text-base font-normal'
        this.highlight.message = `We didn't find that address.`
        this.highlight.message4 = 'Please check the following fields and try again.'
        this.highlight.message2 = 'Enter a valid street address'
        this.highlight.message3 = 'Enter a valid ZIP Code'
      } else if (this.highlight.line1) {
        this.highlight.message = 'Street address required.'
        this.highlight.message2 = 'Enter a valid street address'
      } else if (this.highlight.postalCode) {
        this.highlight.message = `ZIP Code required.`
        this.highlight.message3 = 'Enter a valid ZIP Code'
      } else {
        this.highlight.message = ''
      }
    },
    hideSuggestions(name) {
      setTimeout(() => {
        this.typeAhead[name] = false;
      }, 200);
    },
    loadGoogleMapsApi() {
      const loader = new Loader({
        apiKey: this.$store.state.env.googleApiKey, // Replace with your API key
        version: 'weekly',
        libraries: ["places"]
      });

      loader.importLibrary('places').then((places) => {
        this.$store.dispatch('setGoogleAPI', {
          hasLoaded: true,
          sessionToken: new places.AutocompleteSessionToken(),
          sessionTokenCreated: dt.now().toISO(),
          places
        })
      }).catch(() => {
        this.typeAhead.suggestions = []
          captureMessage('Google Places API failed to load for Serviceability Check')
          // The form is currently set to "full" on pageload. For some reason this is causing the form
          // to switch to the single input "quick" version so I am commenting it out.
          // this.changeForm('full', false, 'csg')
      })
    },
    onFocus() {
      if (this.typeAhead.csgSuggestions) {
                // Filter CSG data
                this.typeAhead.suggestions = this.parseCsgSuggestions();
      }
    },
    onInput() {
      if (this.form.autocomplete) {
        this.typeAhead.inputChanged = true;
        if (this.form.completeType === 'google') {
          if (!this.googleAPI.hasLoaded) return this.loadGoogleMapsApi();

          clearTimeout(this.google.debounceTimer);
          this.google.debounceTimer = setTimeout(() => {
            if (this.typeAhead.street.length > 0) {
              this.fetchSuggestions();
            } else {
              this.typeAhead.suggestions = [];
            }
          }, 225);
        } else if (this.typeAhead.csgSuggestions) {
          // filter csg data
          this.typeAhead.suggestions = this.parseCsgSuggestions()
        }
      }
    },
    aptChanged() {
      if (this.typeAhead.csgSuggestions) {
        this.typeAhead.aptSuggestions = this.parseCsgSuggestions('line2')
      }
    },
    parseCsgSuggestions(part = false) {
      if (part) {
        return this.typeAhead.aptSuggestions = this.filterSuggestions(this.formFields[part], this.typeAhead.csgSuggestions, part).filter(a => a?.address[part] !== '')
      }
      return this.filterSuggestions(this.typeAhead.street, this.typeAhead.csgSuggestions).map(suggestion => {
        return {
          ...suggestion,
          formatted: `<strong class="pr-1">${suggestion?.address?.line1} ${suggestion?.address?.line2}</strong><span class="mr-2">${suggestion?.address?.city}, ${suggestion?.address?.stateOrProvince}, ${suggestion?.address?.postalCode}</span>`
        }
      })
    },
    fetchSuggestions() {
      if (!this.googleAPI.autocomplete) this.$store.dispatch('setGoogleAPI', {autocomplete: new this.googleAPI.places.AutocompleteService()});

      this.googleAPI.autocomplete.getPlacePredictions({
        input: this.typeAhead.street,
        sessionToken: this.$store.getters['getGoogleAPISessionToken'],
        types: ['address'],
        componentRestrictions: {country: 'us'},
        fetchDetails: true, // Added this line to get back zip codes for serviceability
      }, (predictions, status) => {
        if (status === this.googleAPI.places.PlacesServiceStatus.OK) {
          this.typeAhead.suggestions = predictions.map(suggestion => {
            return {
              ...suggestion,
              formatted: `<strong class="pr-1">${suggestion?.structured_formatting?.main_text}</strong><span class="mr-2">${suggestion?.structured_formatting?.secondary_text.replace(", USA", "")}</span>`
            }
          })
        }
      }).catch(() => {
        this.typeAhead.suggestions = []
        this.changeForm('full', false, 'manual')
      })
    },
    selectSuggestion(selection) {
      if (selection?.place_id) {
        if (!this.google.placeDetails) this.google.placeDetails = new this.googleAPI.places.PlacesService(document.createElement('div'));

        this.google.placeDetails.getDetails({
          placeId: selection.place_id,
          sessionToken: this.$store.getters['getGoogleAPISessionToken'],
          fields: ['address_components']
        }, (place, status) => {
          if (status === this.googleAPI.places.PlacesServiceStatus.OK) {
            this.highlight = {
              ...this.highlight,
              line1: false,
              line2: false,
              postalCode: false,
              inputChanged: false,
              csgSuggestions: false,
              recaptcha: false,
            }
            this.typeAhead.selectedOption = true;
            this.processPlaceDetails(place);

            // reset the google session token, as it is now used up
            this.$store.dispatch('setGoogleAPI', {sessionToken: null})
          }
        })
      } else {
        this.highlight = {
          ...this.highlight,
          line1: false,
          line2: false,
          postalCode: false,
          inputChanged: false,
          csgSuggestions: false,
          recaptcha: false,
        }
        this.formFields = {
          ...this.formFields,
          ...selection.address,
          ...selection
        }

        this.typeAhead.short = `${this.formFields.line1}`;
        this.updateStreet(this.form.type)
        this.typeAhead.inputChanged = false;
        this.typeAhead.selectedOption = true;
        this.onSubmit()
      }
    },
    processPlaceDetails(place) {
      this.clearFormFields();
      place.address_components.forEach(c => {
        if (c.types.includes('street_number')) {
          this.formFields.line1 = c.long_name
        } else if (c.types.includes('subpremise')) {
          this.formFields.line2 = c.long_name
        } else if (c.types.includes('route')) {
          this.formFields.line1 += ` ${c.long_name}`
        } else if (c.types.includes('locality')) {
          this.formFields.city = c.long_name
        } else if (c.types.includes('administrative_area_level_1')) {
          this.formFields.stateOrProvince = c.short_name
        } else if (c.types.includes('postal_code')) {
          this.formFields.postalCode = c.long_name
        }
      });
      this.typeAhead.long = `${this.formFields.line1}${this.formFields.line2 ? ' ' + this.formFields.line2 : ''}, ${this.formFields.city}, ${this.formFields.stateOrProvince}, ${this.formFields.postalCode}`
      this.typeAhead.short = `${this.formFields.line1}`
      this.updateStreet(this.form.type)
      this.typeAhead.inputChanged = false;
    },
    async onSubmit() {
      this.requestStartTime = new Date().getTime();
      this.typeAhead.inputChanged = this.form.completeType === 'google' ? this.typeAhead.inputChanged : false;
      this.formFields.line1 = this.formFields.line1 === '' ? this.typeAhead.street : this.formFields.line1;
      this.$v.$touch();
      this.highlight = {
        line1: this.$v.formFields.line1.$error || !this.typeAhead.street,
        line2: this.$v.formFields.line2.$error,
        postalCode: this.$v.formFields.postalCode.$error,
        inputChanged: false,
        csgSuggestions: false,
        recaptcha: false,
      }
      this.getErrorMessage()
      
      // Report validation errors
      if (this.$v.$invalid || this.highlight.message) {
        this.checkAvailabilityReporting('Form Validation Error', {
          requestStartTime: this.requestStartTime,
          attemptNumber: this.attempts
        });
      }

      // !this.highlight.message is added in here as a check so that the user cannot proceed past the Check Availability submit while fields are still highlighted due to errors
      if (!this.$v.$invalid && !this.highlight.message) {
        try {
          await this.$recaptchaLoaded(); // wait for recaptcha to load
          // get a recaptcha token with the on_submit action
          this.formFields.recaptchaToken = await this.$recaptcha("on_submit");
          if (this.formFields?.locationId) {
            // If you got a response with multiple addresses, the customer is asked to select from a list:

            this.selectAddressProxy({...this.formFields, emailAddress: ''});
            // this.updateAddress = true
          } else {
            // This is where we query the API from the check address form
            this.checkAddressProxy({...this.formFields, emailAddress: ''});
            this.changeForm('full', this.form.autocomplete, this.form.completeType)
            // this.updateAddress = false
          }
        } catch (error) {
          this.highlight = {
            ...this.highlight,
            recaptcha: true,
          }
        }
      } else {
        this.changeForm('full', this.form.autocomplete, this.form.completeType)
      }
    },
    checkAddressProxy(address) {
      this.$store.dispatch('checkAddress', address, ROOT)
          .then(response => {
            if(this.checkAvailabilityModal.currentCustomerCheck) {
              //active Breezeline account at this address
              this.checkAvailabilityReporting('Active Breezeline Account at this address', {
                requestStartTime: this.requestStartTime,
                attemptNumber: this.attempts
              });
            }

            if (response && typeof response.suggestedAddresses !== 'undefined') {
              //Found multiple addresses
              this.checkAvailabilityReporting('Multiple Addresses', {
                requestStartTime: this.requestStartTime,
                attemptNumber: this.attempts
              });

              this.changeForm('full', true, 'csg')
              this.typeAhead.csgSuggestions = response.suggestedAddresses?.map((item) => {
                return {
                  "locationId": item.locationId,
                  "billerMappingCode": item.billerMappingCode,
                  "dwellingType": item.dwellingType,
                  "address": {
                    "line1": this.capitalize(item.address.line1),
                    "line2": this.capitalize(item.address.line2),
                    "city": this.capitalize(item.address.city),
                    "stateOrProvince": item.address.stateOrProvince,
                    "country": item.address.country,
                    //substring takes an incoming string and pulls out a starting position of 0 and an ending position of 5
                    "postalCode": item.address.postalCode.substring(0, 5)
                  }
                }
              })
              this.typeAhead.suggestions = []
              this.highlight = {
                line1: true,
                line2: true,
                postalCode: false,
                inputChanged: false,
                csgSuggestions: true,
                recaptcha: false,
              }
              this.getErrorMessage()
            } else {
              // Default to "Serviceable Not In Service"
              if(!this.checkAvailabilityModal.currentCustomerCheck) {
                this.checkAvailabilityReporting('Serviceable Not In Service', {
                  requestStartTime: this.requestStartTime,
                  attemptNumber: this.attempts === 0 ? 1 : this.attempts
                });
              }
            
              this.updateAddress = false
              // the dismiss emit event needs to be added in the event that the address is serviceable and that there is a single address
              this.$emit('dismiss')
              this.$store.commit('SET_METADATA', { isAbandonedCart: false });
              this.$store.dispatch('Promotions/fetchPromotions')
              .then(() => { 
                console.log('✅ Promotions reloaded from API');
                this.$store.dispatch('Promotions/refilterPromotions');
              });
             

              if (this.linkTo) {
                window.location = this.linkTo
              } else {
                const offersElement = document.getElementById("offers");
                offersElement.scrollIntoView();
              }
              // this resets the form and all data values stored within
              this.reset()
            }
          })
          .catch(error => {
            if (error.increaseAttempts) {
              this.attempts++
            }
            
            const errorStatus = this.meta.errorStatus
            if(errorStatus) {

              let status = 'Backend Error'; // Default error status
              
              if (errorStatus === "business") {
                status = 'Business Address';
              } else if (errorStatus === "unserviceable") {
                status = 'Non Serviceable';
              } else if (errorStatus === "call_to_order") {
                status = 'Call To Order Only';
              } else if (errorStatus === "address_not_found") {
                status = 'Address Not Found';
              } 
                
              this.checkAvailabilityReporting(status, {
                requestStartTime: this.requestStartTime,
                attemptNumber: this.attempts
              });
            }

            if (this.attempts >= 2) {
              this.checkAvailabilityReporting('Too Many Attempts', {
                requestStartTime: this.requestStartTime,
                attemptNumber: this.attempts
              });
              this.toUnserviceablePage(address)
            }

            this.highlight = {
              line1: true,
              line2: true,
              postalCode: true,
              inputChanged: false,
              csgSuggestions: false,
              recaptcha: false,
            }
            this.changeForm('full', this.form.autocomplete, this.form.completeType)

            if (error.status === 'Too Many Attempts.') {
              this.highlight['message'] = 'We are unable to locate your address. Please call 855-811-5194 to place an order.'
            } else if (error.errorMessage) {
              this.highlight['message'] = error.errorMessage
              this.highlight.message2 = 'Enter a valid street address'
              this.highlight.message3 = 'Enter a valid ZIP Code'
            } else {
              this.getErrorMessage()
            }
          })
    },
    selectAddressProxy(address) {
      // Here I am passing up a request up to the parent component, which is listening to this dismiss to close the modal
      // This dismiss event needs to be added here as well in the case that the address needs additional information like an apartment number for further address verification
      this.$store.dispatch('checkAddress', address, ROOT)
          .then((res) => {
            if(this.checkAvailabilityModal.currentCustomerCheck) {
              //active Breezeline account at this address
              this.checkAvailabilityReporting('Active Breezeline account at this address', {
                requestStartTime: this.requestStartTime,
                attemptNumber: this.attempts
              });
            } else {
              // Default to "Serviceable Not In Service"
              console.log('currentAttempts: ', this.attempts)
              this.checkAvailabilityReporting('Serviceable Not In Service', {
                requestStartTime: this.requestStartTime,
                attemptNumber: this.attempts === 0 ? 1 : this.attempts
              });
            }

            this.updateAddress = false;
            this.$store.commit('SET_METADATA', { isAbandonedCart: false });
            this.$store.dispatch('Promotions/fetchPromotions')
            .then(() => { 
              console.log('✅ Promotions reloaded from API');
              this.$store.dispatch('Promotions/refilterPromotions');
            });
            this.$emit('dismiss');
            this.reset();
          })
          .catch(error => {
            const errorStatus = this.meta.errorStatus

            if(errorStatus) {
              let status = 'Backend Error'; // Default error status
              
              if (errorStatus === "business") {
                status = 'Business Address';
              } else if (errorStatus === "unserviceable") {
                status = 'Non Serviceable';
              } else if (errorStatus === "call_to_order") {
                status = 'Call To Order Only';
              } else if (errorStatus === "address_not_found") {
                status = 'Address Not Found';
              } 
                
              this.checkAvailabilityReporting(status, {
                requestStartTime: this.requestStartTime,
                attemptNumber: this.attempts
              });
            }

            this.highlight = {
              line1: true,
              line2: true,
              postalCode: true,
              inputChanged: false,
              csgSuggestions: false,
              recaptcha: false,
            }
            this.changeForm('full', this.form.autocomplete, this.form.completeType)

            if (error.status === 'Too Many Attempts.') {
              this.highlight['message'] = 'Too many attempts. Please call 855-811-5194 to place an order.'
            } else if (error.errorMessage) {
              this.highlight['message'] = error.errorMessage
            } else {
              this.getErrorMessage()
            }
          });
    },
    cancelModal() {
      this.checkAvailabilityReporting('Modal Cancelled', {
        requestStartTime: this.requestStartTime,
        attemptNumber: this.attempts
      });
      this.$emit('dismiss')
    },
    toUnserviceablePage(address) {
      this.checkAvailabilityReporting('Redirected To Unserviceable Address Page', {
          requestStartTime: this.requestStartTime,
          attemptNumber: this.attempts
      });
      delete address['recaptchaToken']
      window.location = '/unserviceable-address' + this.jsonToQueryString(address)
    },
    jsonToQueryString(json) {
      return '?' +
          Object.keys(json).map(function (key) {
            return encodeURIComponent(key) + '=' +
                encodeURIComponent(json[key]);
          }).join('&');
    },
    updateLocation() {
      this.clearFormFields()
      this.clearTypeAheadFields()
      this.updateAddress = true
    },
  }
};
</script>

